/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  // Note: example console.log handlers verwijderd in CRO-fix mei 2026 —
  // vuurden op elke scroll/resize tick en droegen bij aan INP=270ms.

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // Inject "+20.000 tevreden klanten" inline naast de Fera review-stars op PDP
  function injectCustomerCount() {
    if (!/\/products\//.test(location.pathname)) return;
    if (document.querySelector('.xantho-customers-count')) return;
    var stars = document.querySelector('[id*="fera_product_reviews_summary"], div[class*="fera-product-reviews-summary"], .fera-product-reviews-summary');
    if (!stars) return;
    var span = document.createElement('span');
    span.className = 'xantho-customers-count';
    span.innerHTML = '<span class="xantho-customers-count__sep" aria-hidden="true">·</span>+20.000 tevreden klanten';
    stars.appendChild(span);
    stars.classList.add('xantho-rating-row');
  }
  if (document.readyState !== 'loading') injectCustomerCount();
  else document.addEventListener('DOMContentLoaded', injectCustomerCount);
  setTimeout(injectCustomerCount, 800);
  setTimeout(injectCustomerCount, 2000);

  // Open cart drawer automatically after add-to-cart (CRO feedback)
  var awaitingDrawerOpen = false;
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    awaitingDrawerOpen = true;
    setTimeout(function(){ awaitingDrawerOpen = false; }, 5000);
  }, true);
  // Cart upsell opnieuw initialiseren na elke cart re-render
  function tryInitUpsell() {
    if (typeof window.xanthoInitCartUpsell === 'function') {
      var wrap = document.querySelector('[data-cart-upsell]');
      if (wrap && !wrap.dataset.loaded) window.xanthoInitCartUpsell();
    }
  }
  document.addEventListener('theme:cart:change', function(){ setTimeout(tryInitUpsell, 100); setTimeout(tryInitUpsell, 600); });
  document.addEventListener('theme:cart:reload', function(){ setTimeout(tryInitUpsell, 200); setTimeout(tryInitUpsell, 800); });

  document.addEventListener('theme:cart:change', function() {
    if (!awaitingDrawerOpen) return;
    awaitingDrawerOpen = false;
    var drawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (!drawer) return;
    var popdown = document.querySelector('[data-product-add-popdown-wrapper] .popdown.is-visible, [data-product-add-popdown] .is-visible, .popdown.is-visible');
    if (popdown) popdown.classList.remove('is-visible');
    // Trigger cart reload zodat de drawer de nieuwe regels rendert
    document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
    // Open de drawer kort daarna, zodat reload eerst kan starten
    setTimeout(function(){
      if (!drawer.classList.contains('drawer--visible')) {
        drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: true }));
      }
    }, 50);
  });

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
